<template>
    <div class="notes">
        <div class="info">
            <h3 class="bullet01">On the day before your medical checkup</h3>
            <p class="bullet03 depth">You should avoid heavy drinking or overwork and we recommend you to relex and get enough sleep.​</p>
            <p class="bullet03 depth">Please fill out the questionnaire in advance and bring it with you to the medical checkup.</p>

            <h4 class="bullet02 depth">Fast</h4>
            <p class="bullet03 depth">Have a light meal before 7 pm</p>
            <p class="bullet03 depth">You should not eat anything after 9 pm. (Including water, gum, or cigarette)</p>

            <h4 class="bullet02 depth">Fecal sampling</h4>
            <p class="bullet03 depth">Take a feces sample a day before the checkup if possible</p>
            <p class="bullet03 depth">For those who have reserved a colonoscopy, we will provide you with a separate guideline for details on dietary attention and intake method for the bowel cleansing agent.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">On the day of checkup</h3>
            <p class="bullet03 depth">Breakfast, cigarette, gum, etc. are all not allowed</p>
            <p class="bullet03 depth">When visiting, please bring questionnaire, fecal sampling container, and glasses or contact lenses with you</p>
            <p class="bullet03 depth">Urine test is also included in the checkup list so collect your sample after visiting the reception counter</p>

            <h4 class="bullet02 depth">Medication</h4>
            <p class="bullet03 depth">Blood pressure medicine, anticonvulsant: Take a sip of water in the morning of the checkup day (around 6 am).</p>
            <p class="bullet03 depth">Diabetes medication (including insulin shots): insulin shots or any diabetes drugs should be discontinued from the start of fast.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Others</h3>
            <p class="bullet03 depth">Please do not carry valuables with you.</p>
            <p class="bullet03 depth">For those of childbearing potential, please verify your pregnancy status before the medical checkup.</p>
            <p class="bullet03 depth">We recommend woman patients to have the checkup during non-menstrual period; and those who received hysterectomy need a gynecologic examination to verify any abnormality of endopelvic organs</p>
            <p class="bullet03 depth">For a conscious sedation endoscope, a guardian should be accompanied and self-driving is not possible on the day.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Prohibited drug</h3>
            <p class="bullet03 depth">The diabetes drugs of metformin type (e.g., Diabex, Janumet, Glupa, Trajenta-duo, Amaryl-M) should be discontinued for 48 hours after the checkup if a contrast medium is applied in any of the tests.</p>
            <p class="bullet03 depth">Antithrombotic drug, anticoagulants may lead to bleeding at endoscopic biopsy or polypectomy so those who take an anticoagulant must consult with his/her physician who prescribed the medication to check and
                follow whether to maintain or suspend its
                administration by a week before the checkup at latest and inform us on the day of checkup.</p>

            <ul class="notes__list">
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_01.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_02.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_03.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_04.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_05.jpg" alt=""></div>
                    <div class="tit">Diabex XR</div>
                </li>
            </ul>
        </div>

        <div class="info">
            <h4 class="bullet02">Example of antithrombotic drug</h4>
            <ul class="notes__list">
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_06.jpg" alt=""></div>
                    <div class="tit">Aspirin Protect Tab</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_07.jpg" alt=""></div>
                    <div class="tit">Astrix</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_08.jpg" alt=""></div>
                    <div class="tit">Plavix</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_09.jpg" alt=""></div>
                    <div class="tit">Pletaal Tab</div>
                </li>
            </ul>
        </div>

        <div class="info">
            <h4 class="bullet02">Example of anticoagulant</h4>
            <ul class="notes__list">
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_10.jpg" alt=""></div>
                    <div class="tit">Warfarin</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_11.jpg" alt=""></div>
                    <div class="tit">Paradaxa</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_12.jpg" alt=""></div>
                    <div class="tit">Xarelto</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_13.jpg" alt=""></div>
                    <div class="tit">Eliquis</div>
                </li>
                <li class="notes__item">
                    <div class="img"><img src="/resource/img/img_com03_14.jpg" alt=""></div>
                    <div class="tit">Lixiana</div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>